import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";

const tableHead = [
  "Sr.",
  "Date",
  "Client Name",
  "length",
  "width",
  "Type",
  "List Num",
  "print pdf",
  "Actions",
];

const GetAllListTable = ({ listData = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-material-planning-list/${id}`);
  };

  const handleSubmit = (id) => {
    if (listData) {
      navigate(`/new-material-planning-list/table/${id}`);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {listData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {/* <td>{getId(item?.dcNumber)}</td> */}
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{titleCaseChange(item?.project) || "N/A"}</td>
                <td>{item?.length || "N/A"} Mtr</td>
                <td>{item?.width || "N/A"} Mtr</td>
                <td>{titleCaseChange(item?.hydroponicType) || "N/A"}</td>
                <td>{item?.uniqueNum || "N/A"}</td>
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => handleSubmit(item.id)}
                  >
                    Print Pdf
                  </button>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GetAllListTable;
